<script setup lang="ts">
import ProfileView from "../components/profiles/ProfileView.vue";
import { useI18n } from "vue-i18n";
import Button from "primevue/button";
import Help from "../components/common/Help.vue";
import { trainerDetails } from "../main.ts";
import MainMenu from "../components/common/MainMenu.vue";
import { ref, computed } from "vue";

const { t } = useI18n();

const trainer = trainerDetails;

const activeTab = ref<string>("purchased");

const pageTitle = computed(() =>
    activeTab.value === "buy"
        ? t("profile-overview.tabs.buy")
        : t("profile-overview.tabs.purchased"),
);

const openConsultationLink = () => {
    globalThis.open(t('accessibility.consultation.url'), '_blank', 'noopener,noreferrer');
};
</script>

<template>
    <MainMenu :trainer="trainer" highlight="products" />
    <div class="app-wrapper mb-8">
        <div id="main-content" tabindex="-1" class="header-section mt-8">
            <!-- Consultation button mobile (shown above title) -->
            <div class="consultation-button-mobile md:hidden mt-2">
                <Button
                    class="consultation-btn p-4 font-bold"
                    icon="pi pi-external-link"
                    iconPos="right"
                    :label="t('accessibility.consultation.arrangeConsultation')"
                    :aria-label="t('accessibility.consultation.arrangeConsultation') + ' ' + t('accessibility.links.externalLink')"
                    @click="openConsultationLink"
                />
            </div>
            <!-- Mobile layout: Title only (button shown above) -->
            <div class="md:hidden">
                <TitleHeadline :title="pageTitle" :subtitle="t('profile-overview.subHeading')" />
            </div>

            <!-- Desktop layout -->
            <div class="hidden md:flex md:items-start md:justify-between md:gap-12">
                <div class="title-container">
                    <TitleHeadline :title="pageTitle" :subtitle="t('profile-overview.subHeading')" :topMargin="0" />
                </div>
                <Button
                    class="consultation-btn mt-auto mb-auto ml-auto p-4 font-bold justify-end"
                    icon="pi pi-external-link"
                    iconPos="right"
                    :label="t('accessibility.consultation.arrangeConsultation')"
                    :aria-label="t('accessibility.consultation.arrangeConsultation') + ' ' + t('accessibility.links.externalLink')"
                    @click="openConsultationLink"
                />
            </div>
        </div>
        <ProfileView v-if="trainer" :trainer="trainer" @update:active-tab="activeTab = $event" />
        <div v-else>
            <Skeleton height="83px" class="mb-4"></Skeleton>
            <Skeleton height="59px" class="mb-4"></Skeleton>
            <Skeleton height="193px" class="mb-4"></Skeleton>
        </div>
        <Help :active="1" :billed="trainer?.purchaseLimit !== 0 || trainer?.distributor.id !== 1" />
    </div>
    <Footer />
</template>

<style scoped>
.consultation-button-mobile {
    text-align: center;
}
</style>
